import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { Authenticated, Authentication } from "@constants/TokenKeys";
import { WebRoutes } from "@constants/WebRoutes";

import EntryPageView from "./EntryPage.View";
import EntryPageViewModel from "./EntryPage.ViewModel";

export function EntryPage() {
    const _viewModel = EntryPageViewModel();
    const navigate = useNavigate();

    //#region Effect Hooks
    useEffect(() => {
        const authCookie = localStorage.getItem(Authentication);

        if (authCookie !== null && authCookie === Authenticated) {
            _viewModel.logOut();
        }
    }, []);

    //#endregion

    //#region Handlers
    function handleLocalizationChangeLang() {
        return null;
    }

    function handleEntryPageStudentBtnClick() {
        navigate(WebRoutes.StudentLoginPage);
    }

    function handleNotLoggedCompanySpanClick() {
        navigate(WebRoutes.UserLoginPage);
    }

    //#endregion

    return (
        <EntryPageView
            onLocalizationChangeLang={handleLocalizationChangeLang}
            onEntryPageStudentBtnClick={handleEntryPageStudentBtnClick}
            onNotLoggedCompanySpanClick={handleNotLoggedCompanySpanClick}
        />
    );
}
